import NoResponse from '@components/dynamic-survey/details/NoResponse';
import ResponseInsight from '@components/interview/details/ResponseInsght';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import ErrorBoundary from '@components/ErrorBoundary';
import {
  useFetchTeamMembers,
  useInterviewDetailsAnalysis,
  useSingleInterview,
} from '@hooks/getQueries';
import { useUserPermission } from '@hooks/userPermission';
import { useParams } from 'react-router';

const ResponseInsightContainer = () => {
  const { id } = useParams();
  const { data: interview, isPending } = useSingleInterview(id);
  const { data } = useInterviewDetailsAnalysis({ id });
  const { data: teamMembers } = useFetchTeamMembers({
    studyId: id,
    studyUrlType: 'qualitative-studies',
  });
  const { canEdit } = useUserPermission({
    entity: interview,
    teamMembers: teamMembers,
  });

  if (isPending) return <Spinner />;

  const stats = data?.completion_statistics || {};
  const totalResponses =
    (stats.total_completed_human || 0) +
    (stats.total_completed_ai || 0) +
    (stats.total_incomplete || 0) +
    (stats.total_active || 0) +
    (stats.total_draft || 0) +
    (stats.total_uploaded || 0) +
    (stats.total_ai_participant || 0);

  return (
    <>
      {interview?.is_primary && totalResponses === 0 ? (
        <NoResponse study={interview} />
      ) : (
        <ResponseInsight
          canEdit={canEdit}
          completionStatistic={data?.completion_statistics}
          deviceUsages={data?.device_usage}
          surveyParticipant={data?.survey_participation}
          timeToComplete={data?.time_to_complete || []}
          hideVoiceFeatureUsages={true}
        />
      )}
    </>
  );
};

export default function InterviewResponseInsights() {
  return (
    <PageContainer title={'Interview | Response Insight'}>
      <ErrorBoundary>
        <ResponseInsightContainer />
      </ErrorBoundary>
    </PageContainer>
  );
}
